// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const CustomerReviewStatus = {
  Pending: {
    Name: 'Pending',
    Value: 'pending',
  },
  Published: {
    Name: 'Published',
    Value: 'published',
  },
  Hidden: {
    Name: 'Hidden',
    Value: 'hidden',
  },
  Rejected: {
    Name: 'Rejected',
    Value: 'rejected',
  },
} as const

export type CustomerReviewStatusValue =
  (typeof CustomerReviewStatus)[keyof typeof CustomerReviewStatus]['Value']
